import apiService from './apiService';

import { Client } from '../types';

const clientService = {
  getAll: async (): Promise<Client[]> => {
    const response = await apiService.get('/api/admin/clients');
    return response.data;
  },

  getOne: async (id: number): Promise<Client> => {
    const response = await apiService.get(`/api/admin/clients/${id}`);
    return response.data;
  },

  create: async (data: Partial<Client>): Promise<Client> => {
    const response = await apiService.post('/api/admin/clients', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Client>): Promise<Client> => {
    const response = await apiService.put(`/api/admin/clients/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await apiService.delete(`/api/admin/clients/${id}`);
    return response.data;
  },
};

export default clientService; 